import client from "../api";
import urls from "../api/urls";

export const getNumber = (n) => (n < 10 ? `0${n}` : n);
export const getImageUrl = (url) =>
  url?.includes("http") || url?.includes("file://")
    ? url
    : client.getUri() + urls.files.baseUrl + url;

export const currencyFormatter = (n, pre = "₦") =>
  (pre || "") + n?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export function capitalizeFirstLetter(string) {
  if (string.length === 0) return string; // handle empty strings
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function objectToFormData(
  obj,
  formData = new FormData(),
  parentKey = null
) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];
      const fullKey = parentKey ? `${parentKey}[${key}]` : key;

      if (
        typeof value === "object" &&
        value !== null &&
        !Array.isArray(value)
      ) {
        objectToFormData(value, formData, fullKey);
      } else if (Array.isArray(value)) {
        value.forEach((item, index) => {
          objectToFormData(item, formData, `${fullKey}[${index}]`);
        });
      } else {
        formData.append(fullKey, value);
      }
    }
  }

  return formData;
}

export const selectFromObject = (fields = [], obj) => {
  const output = {};
  fields.forEach((f) => {
    output[f] = obj[f];
  });
  return output;
};

export const excludeFromObject = (fields = [], obj) => {
  const output = {};
  Object.keys(obj).forEach((f) => {
    if (!fields.includes(f)) {
      output[f] = obj[f];
    }
  });
  return output;
};

export function formatDate(date) {
  date = new Date(date);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // If the date is in the future, return tomorrow or the day and month with year.
  if (date > now) {
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);

    if (date.toDateString() === tomorrow.toDateString()) {
      return "Tomorrow";
    } else {
      const day = days[date.getDay()];
      const dayOfMonth = date.getDate();
      const month = months[date.getMonth()];
      const year = date.getFullYear();

      return `${day} ${dayOfMonth}${getDaySuffix(dayOfMonth)} ${month} ${year}`;
    }
  }

  // If the date is within the last minute, return 'just now'.
  if (diffInSeconds <= 10) {
    return "Just now";
  }
  if (diffInSeconds <= 60) {
    const secondsAgo = Math.floor(diffInSeconds);
    return `${secondsAgo}s ago`;
  }

  // If the date is within the last hour, return the time difference in seconds.
  if (diffInSeconds <= 3600) {
    const secondsAgo = Math.floor(diffInSeconds / 60);
    return `${secondsAgo}m ago`;
  }
  if (diffInSeconds <= 3600 * 24) {
    const secondsAgo = Math.floor(diffInSeconds / 3600);
    return `${secondsAgo}h ago`;
  }

  // If the date is within the last 24 hours (but not today), return 'Yesterday at HH:mm'.
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  if (date.toDateString() === yesterday.toDateString()) {
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());
    return `Yesterday at ${hours}:${minutes}`;
  }

  // For dates older than yesterday, format like 'Monday 24th July 2023'.
  const day = days[date.getDay()];
  const dayOfMonth = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${dayOfMonth}${getDaySuffix(dayOfMonth)} ${month} ${year}`;
}

// Helper function to add a suffix to the day of the month (e.g., 1st, 2nd, 3rd, 4th).
function getDaySuffix(day) {
  if (day >= 11 && day <= 13) {
    return "th";
  }
  const lastDigit = day % 10;
  if (lastDigit === 1) {
    return "st";
  } else if (lastDigit === 2) {
    return "nd";
  } else if (lastDigit === 3) {
    return "rd";
  } else {
    return "th";
  }
}

// Helper function to add a leading zero to single-digit numbers.
function padZero(number) {
  return number < 10 ? `0${number}` : number;
}

export const addDaysToDate = (date, days = 0) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);

  return d;
};
